import React, {memo, useEffect, useState} from 'react'
import {
    CallTrackingDataTable,
    MapTransactionType,
    statusTypes,
} from '../../../../../app/@types'
import {Headers, SortKeys, SortOrder} from '../types'
import {
    TransformDate,
    usePaginatedData,
    useSearchedData,
    useSortedData,
} from '../../../../../app/features'
import {THead} from '../components/THead'
import {Pagination} from '../../../content/pagination/Pagination'
import {Search} from '../../../content/forms'
import {Row} from './Row'

type Props = {
    dataTable: CallTrackingDataTable[]
}

const headers: Headers<CallTrackingDataTable>[] = [
    {key: 'called_at', label: 'Date', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'subscriber', label: 'Nom', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'cleverphone', label: 'Numéro de Calltracking', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'callFrom', label: 'De', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'transferTo', label: 'Vers', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'transactiontype', label: 'Statut de l\'appel', className: 'fw-bolder text-muted bg-light min-w-200px'},
    {key: 'duration', label: 'Durée d\'appel', className: 'fw-bolder text-muted bg-light min-w-200px'},
]

const TablesWidget13: React.FC<Props> = memo(({dataTable}) => {

    const [sortKey, setSortKey] = useState<SortKeys<CallTrackingDataTable>>('called_at')
    const [sortOrder, setSortOrder] = useState<SortOrder>('desc')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [data, setData] = useState<CallTrackingDataTable[]>([])
    const dataSorted: CallTrackingDataTable[] = useSortedData({
        data, sortKey, reverse: sortOrder === 'desc',
    })
    const {searchedData, setSearchQuery} = useSearchedData<CallTrackingDataTable>({
        data: dataSorted,
    })
    const paginatedData = usePaginatedData<CallTrackingDataTable>({
        currentPage, itemsPerPage, data: searchedData,
    })

    useEffect(() => {
        const updatedData = dataTable.map(call => ({
            ...call,
            called_at: TransformDate(call.called_at),
            transactiontype: MapTransactionType(call, statusTypes),
        }))

        setData(updatedData)
    }, [dataTable])

    return (
        <>
            <div className="row d-flex justify-content-end my-7">
                <div className="col-12 col-sm-7 col-md-5">
                    <Search setSearchInput={setSearchQuery} />
                </div>
            </div>
            <div className="table-responsive" id="callTracking-step-3">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">

                    <THead headers={headers}
                           sortKey={sortKey}
                           setSortKey={setSortKey}
                           sortOrder={sortOrder}
                           setSortOrder={setSortOrder}
                           children={<th />}
                    />

                    <tbody>
                        <Row paginatedData={paginatedData} />
                    </tbody>
                </table>
            </div>

            <Pagination itemsPerPage={itemsPerPage}
                        totalItems={data.length}
                        setCurrentPage={setCurrentPage}
                        setItemsPerPage={setItemsPerPage}
            />
        </>
    )
})

export {TablesWidget13}